import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {getAmplitudeLeadFormCloseEventProperties, IGetAmplitudeLeadFormCloseEventPropertiesParams} from "./get_amplitude_lead_form_close_event_properties";
import {getAmplitudeLeadFormErrorEventProperties, IGetAmplitudeLeadFormErrorEventPropertiesParams} from "./get_amplitude_lead_form_error_event_properties";
import {
    getAmplitudeLeadFormGenerateLeadEventProperties,
    IGetAmplitudeLeadFormGenerateLeadEventPropertiesParams
} from "./get_amplitude_lead_form_generate_lead_event_properties";
import {getAmplitudeLeadFormStartEventProperties, IGetAmplitudeLeadFormStartEventPropertiesParams} from "./get_amplitude_lead_form_start_event_properties";

export type {
    IGetAmplitudeLeadFormCloseEventPropertiesParams,
    IGetAmplitudeLeadFormErrorEventPropertiesParams,
    IGetAmplitudeLeadFormGenerateLeadEventPropertiesParams,
    IGetAmplitudeLeadFormStartEventPropertiesParams
};

export const trackAmplitudeLeadFormStart = (params: IGetAmplitudeLeadFormStartEventPropertiesParams) => {
    trackAmplitudeEvent("lead_form_start", getAmplitudeLeadFormStartEventProperties(params));
};

export const trackAmplitudeLeadFormClose = (params: IGetAmplitudeLeadFormCloseEventPropertiesParams) => {
    trackAmplitudeEvent("lead_form_close", getAmplitudeLeadFormCloseEventProperties(params));
};

export const trackAmplitudeLeadFormGenerateLead = (params: IGetAmplitudeLeadFormGenerateLeadEventPropertiesParams) => {
    trackAmplitudeEvent("generate_lead", getAmplitudeLeadFormGenerateLeadEventProperties(params));
};

export const trackAmplitudeLeadFormError = (params: IGetAmplitudeLeadFormErrorEventPropertiesParams) => {
    trackAmplitudeEvent("lead_form_error", getAmplitudeLeadFormErrorEventProperties(params));
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {getAmplitudeLeadFormCloseEventProperties, IGetAmplitudeLeadFormCloseEventPropertiesParams} from "./get_amplitude_lead_form_close_event_properties";
import {getAmplitudeLeadFormErrorEventProperties, IGetAmplitudeLeadFormErrorEventPropertiesParams} from "./get_amplitude_lead_form_error_event_properties";
import {
    getAmplitudeLeadFormGenerateLeadEventProperties,
    IGetAmplitudeLeadFormGenerateLeadEventPropertiesParams
} from "./get_amplitude_lead_form_generate_lead_event_properties";
import {getAmplitudeLeadFormStartEventProperties, IGetAmplitudeLeadFormStartEventPropertiesParams} from "./get_amplitude_lead_form_start_event_properties";

export type {
    IGetAmplitudeLeadFormCloseEventPropertiesParams,
    IGetAmplitudeLeadFormErrorEventPropertiesParams,
    IGetAmplitudeLeadFormGenerateLeadEventPropertiesParams,
    IGetAmplitudeLeadFormStartEventPropertiesParams
};

export const trackAmplitudeLeadFormStart = (params: IGetAmplitudeLeadFormStartEventPropertiesParams) => {
    trackAmplitudeEvent("lead_form_start", getAmplitudeLeadFormStartEventProperties(params));
};

export const trackAmplitudeLeadFormClose = (params: IGetAmplitudeLeadFormCloseEventPropertiesParams) => {
    trackAmplitudeEvent("lead_form_close", getAmplitudeLeadFormCloseEventProperties(params));
};

export const trackAmplitudeLeadFormGenerateLead = (params: IGetAmplitudeLeadFormGenerateLeadEventPropertiesParams) => {
    trackAmplitudeEvent("generate_lead", getAmplitudeLeadFormGenerateLeadEventProperties(params));
};

export const trackAmplitudeLeadFormError = (params: IGetAmplitudeLeadFormErrorEventPropertiesParams) => {
    trackAmplitudeEvent("lead_form_error", getAmplitudeLeadFormErrorEventProperties(params));
};
